<template>
  <div>
    <aw-product-list-page
      :category="category"
    />
    <aw-content-seo-text
      v-if="isShop && category?.seoTextId"
      :content-id="category.seoTextId"
      :class="$style.seoTextContent"
    />
  </div>
</template>

<script setup>
  import { defineAsyncComponent } from 'vue';
  import AwProductListPage from '~~/common/components/Page/ProductList/AwProductListPage';

  const AwContentSeoText = defineAsyncComponent(() => import('~~/shop/app/components/AwContentSeoText'));

  defineProps({
    category: {
      type: Object,
      required: true,
    },
  });

  const isShop = __AW_IS_SHOP__;
</script>


<style module lang="scss" rel="stylesheet/scss">
.seoTextContent {
  margin-top: 30px;
}
</style>


